import Vue from "vue";
import Router from "vue-router";
import AuthRoutes from "../modules/auth/routes";
import FleetRoutes from "../modules/fleetUser/routes";
import FleetVehicles from "../modules/fleetVehicle/routes";
import RestrictionsRoutes from "../modules/restrictions/routes";
import SettingsRoutes from "../modules/settings/routes";
import OrdersRoutes from "../modules/orders/routes";
import ReportsRoutes from "../modules/reports/routes";
import Home from "../views/Home.vue";

import RegisterRoutes from "../modules/register/routes";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () =>
        import(/* webpackChunkName: "fleet" */ "../layout/App.vue"),
      children: [
        {
          path: "",
          name: "home",
          component: Home,
          meta: { auth: true },
        },
        ...FleetRoutes,
        ...FleetVehicles,
        ...RestrictionsRoutes,
        ...SettingsRoutes,
        ...OrdersRoutes,
        ...ReportsRoutes,
      ],
    },
    ...AuthRoutes,
    ...RegisterRoutes,
  ],
});
